import React, { useState } from "react";
import BarekamText from "../../../../../pages/components/text";
import Message from "../../../../../pages/components/message";
import { MessageSections } from "../../../../../pages/components/message/message";
import { SettingsContainer, SettingsTabContainer } from "../../../../../pages/user/settings/styled";
import { ActionBarWithSaveButton } from "../../../../../pages/user/settings/user-actionbar/action-bar-with-save-button";
import { SaveResultType } from "../../../../../pages/shared/enum/save-result-type";
import { AxiosError } from "axios";
import BarekamCheckbox from "../../../../../pages/components/checkbox";
import { GapContainer } from "../../../../../pages/components/card/styled";
import { UserDisabledInputsContainer } from "../../../../../pages/user/settings/personal-info/user-inputs/styled";
import { CountryModel } from "../../../../../pages/shared/models/countryModel";
import countryService, { CountryUpdateMeta } from "../../../../../services/country-service";
import { useAppSelector } from "../../../../../redux/store";
import { ToastContainer } from "react-toastify";
import { initToast, getMessage } from "../../../../../pages/shared/helper-functions";

export const CountryInfo = ({ country }: { country: CountryModel }) => {
    const [isModified, setIsModified] = useState(false);
    const { languageId, messageCache } = useAppSelector(state => state.messagesReducer);

    const [modifiedCountry, setModifiedCountry] = useState<CountryModel>({
        hasActiveWarehouse: country.hasActiveWarehouse,
    } as CountryModel);

    function saveCountry() {
        return countryService.updateById(country.countryId, modifiedCountry)
            .then((response: CountryUpdateMeta) => {
                if (response.acknowledged) {
                    const toastMessage = getMessage("saved", MessageSections.USER, messageCache, languageId);
                    const tooltipType = "success";

                    initToast(toastMessage, tooltipType);
                    setIsModified(false);
                    return { status: SaveResultType.SUCCESS, payload: {} }
                }
            })
            .catch((e: any) => {
                if (e instanceof AxiosError) {
                    return e.response?.data;
                }
            })
    }

    function toggleCheckBox(field: 'hasActiveWarehouse') {
        setIsModified(true);

        setModifiedCountry(prevState => {
            prevState[field] = !prevState[field]

            return { ...prevState };
        })
    }

    const PrimaryActionText = () => (
        <BarekamText variant={"m"} bold>
            <Message messageKey={'save'} sectionId={MessageSections.USER} />
        </BarekamText>
    )

    return (
        <SettingsContainer>
            <ActionBarWithSaveButton disabled={!!country}
                headerText={<div />}
                primaryActionText={isModified ? <PrimaryActionText /> : undefined}
                onPrimaryActionClick={saveCountry} />
            <SettingsTabContainer>
                <UserDisabledInputsContainer>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={"country"} sectionId={MessageSections.MAIN} />
                    </BarekamText>

                    <BarekamText variant={"s"} fontWeight={500}>
                        {country.name[languageId]}
                        {` / ${country.abbreviation}`}
                    </BarekamText>
                </UserDisabledInputsContainer>

                <GapContainer>
                    <BarekamCheckbox checked={modifiedCountry.hasActiveWarehouse}
                        onClick={() => toggleCheckBox('hasActiveWarehouse')} />

                    <BarekamText variant={'m'} opaque>
                        <Message messageKey={'has_active_warehouse'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </GapContainer>
            </SettingsTabContainer>
            <ToastContainer />
        </SettingsContainer>
    );
}